import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';

import COLORS from 'styles/constants/colors';

interface ProductCardDetailsProps {
  isEcomProduct: boolean;
}

const setMinimumHeight = css`
  min-height: 430px;
  flex-grow: 1;

  ${MEDIA_QUERIES.mdUp} {
    min-height: 410px;
  }
`;

export const ProductCardContainer = styled.div<ProductCardDetailsProps>`
  display: flex;
  flex-direction: column;
  width: min-content;
  background: ${(props) =>
    props.isEcomProduct ? COLORS.surfaceWhite : 'inherit'};
  position: relative;

  ${(props) => props.isEcomProduct && setMinimumHeight}
  margin-bottom: ${SPACER.medium};
`;

export const Name = styled.span`
  font-weight: 700;
`;

export const Description = styled.p`
  font-size: 0.75rem;
`;

export const Price = styled.p`
  font-weight: 700;
`;

export const ProductCardDetails = styled.div<ProductCardDetailsProps>`
  padding: ${(props) => (props.isEcomProduct ? '0 1rem' : 'none')};
`;
